module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', [_c('mu-icon-button', {
    staticClass: "notificationBtn",
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "icon": _vm.icon
    },
    nativeOn: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }), _vm._v(" "), (_vm.showIndicator && _vm.newNotifications) ? _c('img', {
    staticClass: "newIndicator",
    attrs: {
      "src": require("assets/indicator-dot.png")
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.visible) ? _c('mu-card', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    attrs: {
      "id": "notifications"
    }
  }, [_c('mu-card-header', {
    class: {
      'newNotifs': _vm.newNotifications
    },
    staticStyle: {
      "padding": "10px 0 0 0"
    },
    attrs: {
      "titleClass": "blueTitle notificationTitle",
      "title": _vm.$t('message.notificationHeaderText')
    }
  }, [(_vm.newNotifications) ? _c('div', {
    staticClass: "readAll",
    on: {
      "click": function($event) {
        return _vm.markAllRead()
      }
    }
  }, [_c('span', [_vm._v("Mark all read")])]) : _vm._e()]), _vm._v(" "), (!_vm.newNotifications) ? _c('div', {
    staticClass: "notificationsEmpty"
  }, [_c('mu-icon', {
    attrs: {
      "value": "notifications_none",
      "size": "80",
      "color": "#a8abb9"
    }
  }), _vm._v(" "), _c('p', [_vm._v("You haven't received any new notifications yet")])], 1) : _vm._e(), _vm._v(" "), (_vm.newNotifications) ? _c('div', {
    staticClass: "scrollable",
    staticStyle: {
      "overflow": "auto",
      "-webkit-overflow-scrolling": "touch"
    },
    attrs: {
      "id": "notificationScroller"
    }
  }, [_c('mu-list', _vm._l((_vm.notifications), function(item, index) {
    return _c('mu-list-item', {
      key: 'n-' + index,
      class: {
        notificationTextNewBg: item.isViewed === null
      },
      attrs: {
        "title": _vm.generateText(item),
        "titleClass": {
          notificationText: item.isViewed === true,
          notificationTextNew: item.isViewed === false
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.markReadAndGo(item)
        }
      }
    }, [(item.user) ? _c('div', {
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [(item.user.profile_thumb) ? _c('mu-avatar', {
      staticClass: "notificationAvatar",
      attrs: {
        "src": item.user.profile_thumb,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      }
    }) : _c('mu-avatar', {
      staticClass: "notificationAvatar",
      attrs: {
        "color": "black",
        "backgroundColor": "#E9E9E8"
      }
    }, [_vm._v(_vm._s(item.user.firstname.substring(0, 1)))])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      class: {
        'notificationTextNew': !item.isViewed
      },
      staticStyle: {
        "font-family": "'Poppins',sans-serif",
        "font-size": "16px",
        "line-height": "1.4",
        "font-weight": "400"
      },
      domProps: {
        "textContent": _vm._s(_vm.formatDate(item.date_created))
      }
    })])])
  }), 1), _vm._v(" "), (_vm.isAppending) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.notificationEndedFromServer) ? _c('div', {
    staticClass: "wrapBtn"
  }, [_c('mu-flat-button', {
    staticClass: "showMore",
    attrs: {
      "label": "Show more"
    },
    on: {
      "click": function($event) {
        return _vm.showMore()
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e79887e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/Notifications.vue
// module id = 3859
// module chunks = 1